fragment ComputedDeliverable on ComputedDeliverable {
    _id
    computedValues {
        editableId
        name
        type
        value
        layer
        settings
    }
    editableGroupValueIds
    hash
    language
    masterTemplate {
        _id
    }
    metadata {
        _id
        field {
            _id
            name
        }
        value
    }
    publishedStatus
    status
    users {
        user {
            id
            role {
                actions
                name
            }
        }
        status
    }
    visibleTo
    reportingLabel
}
